import PropTypes from "prop-types"
import SamplingRequest from "modules/saxony/components/SamplingRequest"
import ModalContext from "modules/saxony/components/SamplingRequest/context"

const RequestsSection = ({ modalContext, toggable, toggle }) => {
  return (
    <>
      <ModalContext.Provider value={modalContext ?? ""}>
        <SamplingRequest isOpen={toggable} toggle={toggle} />
      </ModalContext.Provider>
    </>
  )
}

RequestsSection.propTypes = {
  modalContext: PropTypes.object,
  toggable: PropTypes.bool,
  toggle: PropTypes.func
}

export default RequestsSection
